<template>
  <session-content-container :title="title">
    <template #right>
      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="$t('animation.networkdiagram.finishGame.message')"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.validate')"
        validation-btn-color="accent"
        @confirm="finishGame"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingFinishGame"
            :disabled="loadingFinishGame || isAllPlayerFinished"
            small
            color="accent"
            v-bind="attrs"
            v-on="on"
            v-text="$t('animation.networkdiagram.finishGame.button')"
          />
        </template>
      </ag-confirm-dialog>
    </template>
    <template v-if="game">
      <v-row no-gutters>
        <v-col
          v-for="player in game.playerList"
          :key="player.id"
          class="pa-2 d-flex flex-column"
          cols="12"
          lg="6"
        >
          <player-card
            :value="player"
            class="flex-grow-1"
            :number-of-instructions="game.numberOfInstructions"
          />
        </v-col>
      </v-row>
    </template>
  </session-content-container>
</template>

<script>
import { mapActions } from 'vuex'
import _throttle from 'lodash/throttle'
import Repositories from 'src/repositories'

import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import SessionContentContainer from '../SessionContentContainer'
import PlayerCard from '../../components/network-diagram/PlayerCard'

export default {
  name: 'NetworkDiagramWithInstructionsContainer',
  components: {
    AgConfirmDialog,
    SessionContentContainer,
    PlayerCard,
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    gameId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    game: null,
    loading: false,
    loadingFinishGame: false,
  }),
  computed: {
    title () {
      if (this.loading) {
        return this.$t('general.loading')
      }
      return this.$t('animation.menu.games.networkDiagramWithInstructions')
    },
    isAllPlayerFinished () {
      return this.game?.playerList
        .every(player => player.status === 'finished')
    },
  },
  sockets: {
    trainingSessionPlayerLoggedIn ({ idSession }) {
      if (this.sessionId === idSession) {
        this.fetchData()
      }
    },
    networkDiagramSessionPlayerPlaying ({ networkDiagramSessionId }) {
      if (networkDiagramSessionId === this.gameId) {
        this.fetchData()
      }
    },
    networkDiagramSessionPlayerFinished ({ networkDiagramSessionId }) {
      if (networkDiagramSessionId === this.gameId) {
        this.fetchData()
      }
    },
    networkDiagramSessionPlayerSaveProgress ({ networkDiagramSessionId }) {
      if (networkDiagramSessionId === this.gameId) {
        this.delayedFetchData()
      }
    },
    networkDiagramSessionPlayerNextInstruction ({ networkDiagramSessionId }) {
      if (networkDiagramSessionId === this.gameId) {
        this.delayedFetchData()
      }
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.fetchData()
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showErrorNotification: 'showErrorNotification',
    }),
    fetchData: _throttle(async function fetchData () {
      this.game = await Repositories.animation.networkdiagram.get(this.gameId)
      // Show message only during the first load (not on data refresh)
      this.loading = false
    }, 200, { leading: true, trailing: true }),
    delayedFetchData: _throttle(async function fetchData () {
      this.game = await Repositories.animation.networkdiagram.get(this.gameId)
    }, 2500, { leading: true, trailing: true }),
    async finishGame () {
      this.loadingFinishGame = true
      try {
        await Repositories.animation.networkdiagram.sendAction({
          gameId: this.gameId,
          actionName: 'finishGame',
        })
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
        console.error(error)
      }
      finally {
        this.loadingFinishGame = false
      }
    },
  },
}
</script>
